import { StyledBranchLabelContainer, StyledBranchConnector, StyledConnectorLine, StyledBranchConnectorButton } from 'automation-ui-directed-graph/ConnectorStyledComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function BranchConnector({
  color,
  onRenderBranchName,
  edge,
  children,
  edgeThickness
}) {
  return /*#__PURE__*/_jsxs(StyledBranchConnector, {
    children: [/*#__PURE__*/_jsx(StyledBranchLabelContainer, {
      children: onRenderBranchName(edge.getId())
    }), /*#__PURE__*/_jsx(StyledConnectorLine, {
      color: color,
      edgeThickness: edgeThickness
    }), /*#__PURE__*/_jsx(StyledBranchConnectorButton, {
      children: children
    })]
  });
}
export default BranchConnector;